import { css } from "@emotion/css";
import { rgba } from "emotion-rgba";
import palette from "utility/ui/palette";

const styles = {
  collapse: (open, color) =>
    open
      ? css`
          &::after {
            content: none;
          }
        `
      : css`
          &::after {
            position: absolute;
            bottom: 4rem;
            right: 0;
            width: 100%;
            height: 4rem;
            content: "";
            background: -moz-linear-gradient(0deg, ${rgba(palette[color], 1)} 0%, ${rgba(palette.white, 0)} 100%);
            background: ${rgba(palette[color], 1)};
            background: -o-linear-gradient(0deg, ${rgba(palette[color], 1)} 0%, ${rgba(palette.white, 0)} 100%);
            background: -ms-linear-gradient(0deg, ${rgba(palette[color], 1)} 0%, ${rgba(palette.white, 0)} 100%);
            background: -webkit-linear-gradient(0deg, ${rgba(palette[color], 1)} 0%, ${rgba(palette.white, 0)} 100%);
            background: linear-gradient(0deg, ${rgba(palette[color], 1)} 0%, ${rgba(palette.white, 0)} 100%);
          }
        `,
};

export default styles;
